export const PAGE_FETCH = "PAGE_FETCH";
export const PAGE_FETCH_SUCCESS = "PAGE_FETCH_SUCCESS";
export const PAGE_RESET = "PAGE_RESET";
